function setProjectActive(id){
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        /* the route pointing to the post function */
        url: '/planner/activateProject',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: "id=" + id,
        dataType: 'JSON',
        /* remind that 'data' is the response of the AjaxController */

        // Remove deactive classes and button from selected project to activate without reloading the page
        success: function (data) {
            var project = $('[data-project-id="' + id + '"]');
            $(project).removeClass('project-list-item-inactive');
            $(project).find('button').tooltip('hide');

            $(project).find('button').attr('data-original-title', 'Maak inactief');
            $(project).find('button').find('i').addClass('fa fa-eye-slash');
            $(project).find('button').attr("onclick","setProjectInactive("+ id +")");
        }
    });
}

window.setProjectActive = setProjectActive;

function setProjectInactive(id){
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        /* the route pointing to the post function */
        url: '/planner/inactivateProject',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: "id=" + id,
        dataType: 'JSON',
        /* remind that 'data' is the response of the AjaxController */

        // Remove deactive classes and button from selected project to activate without reloading the page
        success: function (data) {
            var project = $('[data-project-id="' + id + '"]');
            $(project).addClass('project-list-item-inactive');
            $(project).find('button').tooltip('hide');

            $(project).find('button').attr('data-original-title', 'Maak actief');
            $(project).find('button').find('i').removeClass();
            $(project).find('button').find('i').addClass('fa fa-eye');
            $(project).css("display", "none");
            $(project).find('button').attr("onclick","setProjectActive("+ id +")");

        }
    });
}

window.setProjectInactive = setProjectInactive;


// WEBPACK FOOTER //
// ./resources/js/components/ajaxPosts.js